import { useEffect } from 'react';
import { Providers } from './Providers';
import { Router } from './router/Router';
import { isDemo, isProduction } from 'constants/env';

function App() {
  useEffect(() => {
    if (isProduction && !isDemo) {
      const script = document.createElement('script');
      script.src = 'https://js.hs-scripts.com/7805184.js';
      script.id = 'hs-script-loader';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <Providers>
      <Router />
    </Providers>
  );
}

export default App;
